import axiosInstance from "../Utils/axiosInstance";
export interface BackOfficeTrade {
  id: string;
  formatted_date: string;
  pricing_from_formatted: string;
  pricing_to_formatted: string;
  exec_id: string;
  leg_id: string;
  commodity_name: string;
  quantity: number;
  unit_name: string;
  price: number;
  book_name_resolved: string;
  status: string;
  updated_by: string;
  updated_at: string;
}

interface ApiResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: BackOfficeTrade[];
}

export interface UserDetails {
  name: string;
  email: string;
  organization: string;
  user_group: string;
  user_type: string;
}

export interface UserApiResponse {
  message: string;
  data: UserDetails;
}

export const fetchBackOfficeTrades = async (): Promise<BackOfficeTrade[]> => {
  const response = await axiosInstance.get<ApiResponse>(
    "/paper-app/back-office"
  );
  return response.data.results;
};

export const bulkChangeTradeStatus = async (
  execIds: string[],
  status: "pending" | "committed" | "validated" | "approved" | "rejected"
): Promise<void> => {
  await axiosInstance.post("/paper-app/back-office/bulk-change-status/", {
    exec_id: execIds,
    status,
  });
};

export const fetchUserDetails = async (): Promise<UserDetails> => {
  const response = await axiosInstance.get<UserApiResponse>(
    "/users/user-details/"
  );
  return response.data.data; 
};